import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, fmtError } from "@/lib/api";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(() => {
    const n = sessionStorage.getItem("admin_notice") || "";
    sessionStorage.removeItem("admin_notice");
    return n;
  });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(fmtError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen flex items-center justify-center bg-white px-6" style={{ fontFamily: '"Manrope", system-ui, sans-serif' }}>
      <form onSubmit={submit} className="w-full max-w-md border-2 border-black p-8 bg-white">
        <p className="text-xs uppercase tracking-[0.3em] text-black/50 mb-3">Admin · Portfolio</p>
        <h1 className="text-4xl font-black tracking-tight leading-none mb-8" style={{ fontFamily: '"Bricolage Grotesque", system-ui' }}>
          Welcome back<span style={{ color: "#B0121A" }}>.</span>
        </h1>

        <label className="block text-xs uppercase font-bold tracking-wider mb-1">Email</label>
        <input
          data-testid="admin-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-transparent border-b-2 border-black/15 focus:border-black py-2 text-lg outline-none mb-5"
          placeholder="sa9858@nyu.edu"
          autoComplete="username"
        />

        <label className="block text-xs uppercase font-bold tracking-wider mb-1">Password</label>
        <input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-transparent border-b-2 border-black/15 focus:border-black py-2 text-lg outline-none mb-6"
          placeholder="••••••••"
          autoComplete="current-password"
        />

        {err && (
          <p data-testid="login-error" className="text-sm font-bold mb-4" style={{ color: "#B0121A" }}>
            {err}
          </p>
        )}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 text-white font-bold uppercase tracking-wider rounded-full hover:scale-[1.02] transition-transform disabled:opacity-60"
          style={{ background: "#B0121A" }}
        >
          {loading ? "Signing in…" : <><LogIn size={16} /> Sign in</>}
        </button>

        <p className="text-xs text-black/50 mt-6 text-center">
          Owner-only portfolio editor.
        </p>
      </form>
    </div>
  );
}
